import Vue from "vue";
import VueRouter from "vue-router";
import App from "../App.vue";


Vue.use(VueRouter);

const routes = [{
	path: "/",
	name: "App",
	component: App,
	children: [
		// {
		// 	path: "/login",
		// 	name: "login",
		// 	component: () => import("../views/login.vue")
		// },
		{
			path: "/",
			name: "home",
			component: () => import("../views/home.vue")
		},
		// {
		// 	path: "/customer",
		// 	name: "customer_home",
		// 	component: () => import("../views/customer/customer_home.vue")
		// },
		// {
		// 	path: "/admin",
		// 	name: "admin_home",
		// 	component: () => import("../views/admin/admin_home.vue")
		// },
		// {
		// 	path: "/coach",
		// 	name: "coach_home",
		// 	component: () => import("../views/coach/coach_home.vue")
		// },
		// {
		// 	path: "/test",
		// 	name: "test",
		// 	component: () => import("../views/test.vue")
		// },
		// {
		// 	path: "/regist",
		// 	name: "regist",
		// 	component: () => import("../views/regist.vue")
		// },
		// {
		// 	path: "/activate",
		// 	name: "activate",
		// 	component: () => import("../views/activate.vue")
		// },

		{
			path: "/pay_success",
			name: "PaySuccess",
			component: () => import("../views/payment/PaySuccess.vue")
		},
		{
			path: "/pay_success2",
			name: "PaySuccess2",
			component: () => import("../views/payment/PaySuccess2.vue")
		},
		{
			path: "/pay_cancel",
			name: "PayCancel",
			component: () => import("../views/payment/PayCancel.vue")
		},
		{
			path: "/training",
			name: "TrainingPeadks",
			component: () => import("../views/payment/TrainingPeadks.vue")
		},
		{
			path: "/cameleonform",
			name: "CameleonForm",
			component: () => import("../views/payment/CameleonForm.vue")
		},
		{
			path: "/lineadd",
			name: "LineAdd",
			component: () => import("../views/payment/LineAdd.vue")
		},
		{
			path: "/finishset",
			name: "FinishSet",
			component: () => import("../views/payment/FinishSet.vue")
		},
		{
			path: "/PlanLeg1",
			name: "PlanLeg1",
			component: () => import("../views/payment/PlanLeg1.vue")
		},
		{
			path: "/PlanLeg2",
			name: "PlanLeg2",
			component: () => import("../views/payment/PlanLeg2.vue")
		},
		{
			path: "/PlanLeg3",
			name: "PlanLeg3",
			component: () => import("../views/payment/PlanLeg3.vue")
		},
		{
			path: "/PlanDiet1",
			name: "PlanDiet1",
			component: () => import("../views/payment/PlanDiet1.vue")
		},
		{
			path: "/PlanDiet2",
			name: "PlanDiet2",
			component: () => import("../views/payment/PlanDiet2.vue")
		},
		{
			path: "/PlanDiet3",
			name: "PlanDiet3",
			component: () => import("../views/payment/PlanDiet3.vue")
		},
		{
			path: "/PlanGachi1",
			name: "PlanGachi1",
			component: () => import("../views/payment/PlanGachi1.vue")
		},
		{
			path: "/PlanGachi2",
			name: "PlanGachi2",
			component: () => import("../views/payment/PlanGachi2.vue")
		},
		{
			path: "/PlanGachi3",
			name: "PlanGachi3",
			component: () => import("../views/payment/PlanGachi3.vue")
		},
	]
}];

const router = new VueRouter({
	mode: 'history',
	routes
});

export default router;
